import React, { useRef } from 'react';
import { Info16x16 } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { Tooltip } from 'shared/components/ui/tooltip';

import * as Styled from './tag-match-mode-options.style';

export type TagMatchModeInfoIconProps = {
  description: string;
};

const stopPropagation = (event: React.MouseEvent) => {
  event.stopPropagation();
};

export const TagMatchModeInfoIcon: React.FC<TagMatchModeInfoIconProps> = ({
  description,
}) => {
  const ref = useRef<HTMLSpanElement>(null);

  return (
    <>
      <Styled.InfoIconContainer ref={ref} onClick={stopPropagation}>
        <Icon icon={Info16x16} color="inherit" />
      </Styled.InfoIconContainer>
      <Tooltip referenceElement={ref} label={description} delay={300} />
    </>
  );
};
